import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import rootSaga from './rootSaga';

//reducers
import { desksReducer } from './desksSlice/desksSlice';
import { transactionsReducer } from './transactionsSlice/transactionsSlice';
import { snackbarsReducer } from './snackbarsSlice/snackbarsSlice';
import { tableControlReducer } from './tableControlSlice/tableControlSlice';
import { formControlReducer } from './formControlSlice/formControlSlice';
import { authReducer } from './authSlice/authSlice';
import { generalReducer } from './generalSlice/generalSlice';
import { featureFlagReducer } from './featureFlag/featureFlagSlice';
import { relayActivityReducer } from 'features/relayActivity/store/relayActivitySlice';
import { transactionImageReducer } from './storeTransactionImage/storeTransactionImageSlice';
import { draftMailReducer } from './draftMail/draftMailSlice';
import { playbackReducer } from './playbackSlice/playbackSlice';
import { faceMatchReducer } from './faceMatchSlice/faceMatchSlice';
import { allEventsReducer } from './allEventsSlice/allEventsSlice';
import { fenixYmsReducer } from './fenixYmsSlice/fenixYmsSlice';
import { ocrVerificationReducer } from './ocrVerificationSlice/ocrVerificationSlice';
import { slackReducer } from './slackSlice/slackSlice';
import { streamPermissionsReducer } from './streamPermissionsSlice/streamPermissionsSlice';
import { stepByStepProtocolReducer } from 'features/stepByStepProtocol';

const devTools = import.meta.env.VITE_ENV !== 'production' ? { trace: true, traceLimit: 25 } : false;

export let store = {};
export let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

export const setupStore = (preloadedState) => {
    store = configureStore({
        reducer: {
            forms: formControlReducer,
            desks: desksReducer,
            transactions: transactionsReducer,
            snackbars: snackbarsReducer,
            tables: tableControlReducer,
            auth: authReducer,
            general: generalReducer,
            featureFlag: featureFlagReducer,
            relayActivity: relayActivityReducer,
            storeTransactionImage: transactionImageReducer,
            draftMailTypes: draftMailReducer,
            playback: playbackReducer,
            faceMatch: faceMatchReducer,
            allEvents: allEventsReducer,
            fenixYms: fenixYmsReducer,
            ocrVerification: ocrVerificationReducer,
            slack: slackReducer,
            streamPermissions: streamPermissionsReducer,
            stepByStepProtocol: stepByStepProtocolReducer,
        },
        devTools,
        ...(preloadedState && { preloadedState }),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['transactions/setSharedWorker', 'desks/fetchFailed'],
                    ignoredPaths: ['transactions.sharedWorker'],
                },
            }).concat(middleware),
    });

    sagaMiddleware.run(rootSaga);
    return store;
};
